<template>
  <div class="chat-input p-2 border-t">
    <form @submit.prevent="handleSubmit">
      <div class="flex space-x-1.5">
        <Button
          variant="outline"
          size="sm"
          :disabled="disabled"
          type="button"
          @click="emit('clear')"
        >
          <Icon name="mdi:delete" class="h-3.5 w-3.5" />
        </Button>
        <Textarea
          v-model="localValue"
          :disabled="disabled"
          placeholder="Type your message..."
          class="flex-1 min-h-[36px] py-1.5 px-2 text-sm"
          :rows="1"
          @keydown.enter.prevent="handleEnter"
        />
        <Button type="submit" size="sm" :disabled="disabled || !localValue.trim()">
          <Icon name="mdi:send" class="h-3.5 w-3.5" />
        </Button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
  modelValue: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
  send: [value: string]
  clear: []
}>()

const localValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

const handleSubmit = () => {
  const trimmedMessage = localValue.value.trim()
  if (!trimmedMessage || props.disabled) return

  log('🎯 ChatInput handleSubmit:', { trimmedMessage })
  emit('send', trimmedMessage)
  localValue.value = ''
}

const handleEnter = (event: KeyboardEvent) => {
  if (event.shiftKey) return
  event.preventDefault()
  log('🎯 ChatInput handleEnter')
  handleSubmit()
}
</script>
